export default __webpack_public_path__ + "static/media/12a5e0e0-c3a7-4c8d-9212-0b02f8a69577.3a6cd3da.JPG";